module.exports = __webpack_public_path__ + "static/media/billboard-light.d5b90256.svg";